import axios, { AxiosError } from 'axios';
import { DocumentsCategory } from 'src/interfaces';
import { IDocument } from 'src/interfaces/document';
import { getStorageValue } from 'src/hooks/useLocalStorage';
import http from './http';

class DocumentsService {
  static upload(
    data: FormData,
    documentCategory: DocumentsCategory,
    // eslint-disable-next-line no-unused-vars
    comments?: string
  ) {
    return http
      .post(`/documents?documentCategory=${documentCategory}`, data)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getDocuments(): Promise<IDocument[]> {
    return http
      .get('/documents')
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getDocumentDownloadLink(docId: string) {
    return `${process.env.REACT_APP_API_URL}documents/download/${docId}?token=${getStorageValue('accessToken', null)}`;
  }

  static deleteDocument(docId: string): Promise<void> {
    return http
      .delete(`/documents/${docId}`)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default DocumentsService;
